// @flow

export { InputChileanDocument } from './input-chilean-document';
export { InputChileanPhoneNumber } from './input-chilean-phone-number';
export { InputChileanZipcode } from './input-chilean-zipcode';
